import { render, staticRenderFns } from "./ListOfBoards.vue?vue&type=template&id=420ff328&scoped=true"
import script from "./ListOfBoards.vue?vue&type=script&lang=js"
export * from "./ListOfBoards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420ff328",
  null
  
)

export default component.exports